import {Pattern, match} from 'ts-pattern';

import {browserStorageKey} from '@dms/config';

import type {AppSyncAuthHeader} from '../types';
import {resolveAppSyncHost} from './resolveAppSyncHost';

/**
 * Builds the AppSync authorization header, or `null` when the environment
 * cannot provide one. A malformed URL is reported and stopped by the
 * subscription lifecycle (see `stopForMisconfiguration`), so this builder only
 * logs — it must never throw at the page that opened the socket.
 */
export const buildAuthHeader = (): AppSyncAuthHeader | null =>
  match({
    accessToken: sessionStorage.getItem(browserStorageKey.ACCESS_TOKEN),
    hostResolution: resolveAppSyncHost(process.env.APPSYNC_URL),
  })
    .returnType<AppSyncAuthHeader | null>()
    .with({accessToken: Pattern.nullish}, () => {
      console.error('Access token is not found');
      return null;
    })
    .with({hostResolution: {status: 'notConfigured'}}, () => {
      console.error('AppSync URL is not found');
      return null;
    })
    .with({hostResolution: {status: 'malformed'}}, () => {
      console.error('AppSync URL is malformed');
      return null;
    })
    .with(
      {accessToken: Pattern.string, hostResolution: {status: 'resolved'}},
      ({accessToken, hostResolution}) => ({
        Authorization: accessToken,
        host: hostResolution.host,
      })
    )
    .exhaustive();
